import { useEffect, useState } from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import i18n from '../../../../../utils/i18n';
import CustomButton from '../../../../components/CustomButton';
import AIHeaderClose from '../../../../../images/ai-header-close.svg';
import AIAccountantMan from '../../../../../images/ai-accountant-man.svg';
import SelectorOption from '../../../../components/SelectorOption';
import GeneralBlueTick from '../../../../../images/general-blue-tick.svg';
// import IconPercentageGrey from '../../../../../images/icon-percentage-grey.svg';
import IconAIMedium from '../../../../../images/icon-ai-medium.svg';
import IconAIHigh from '../../../../../images/icon-ai-high.svg';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from '../../../../../redux/action';

const SubscriptionFinalize = ({
	openSubFinalize,
	setOpenSubFinalize,
	setOpenSubSuccess,
	submitToDB,
	sendEmailNotification,
}) => {
	const dispatch = useDispatch();

	const providerSubscription = useSelector(
		(state) => state.provider_subscription
	);
	const providerUserData = useSelector((state) => state.userData);
	const providerPackage = useSelector((state) => state.provider_package);

	// CURRENTLY ONLY TRANSFER AVAILABLE
	const [selectedOption, setSelectedOption] = useState('transfer');

	const handleCloseSubFinalize = () => {
		setOpenSubFinalize(false);
	};

	const handleSelectOption = (option) => {
		setSelectedOption(option);

		dispatch(
			ACTIONS.addProviderInfo({
				id: 'cardPayment',
				data: option === 'card',
				stateObject: 'provider_subscription',
			})
		);
	};

	const addDate = () => {
		let today = new Date(),
			date =
				today.getFullYear() +
				'.' +
				(today.getMonth() + 1 < 10
					? '0' + (today.getMonth() + 1)
					: today.getMonth() + 1) +
				'.' +
				(today.getDate() < 10 ? '0' + today.getDate() : today.getDate());
		return date;
	};

	const saveRegDate = () => {
		// dispatch(
		// 	ACTIONS.addProviderInfo({
		// 		id: 'finishedRegistration',
		// 		data: true,
		// 		stateObject: 'userData',
		// 	})
		// );
		dispatch(
			ACTIONS.addProviderInfo({
				id: 'startDate',
				data: addDate(),
				stateObject: 'provider_package',
			})
		);
	};

	return (
		<Dialog
			open={openSubFinalize}
			onClose={handleCloseSubFinalize}
			PaperProps={{
				sx: {
					width: '420px',
					height: 'auto',
					maxWidth: 'none',
					borderRadius: '18px',
					overflow: 'hidden',
				},
			}}
			sx={{
				'& .MuiDialog-container': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				},
				'& .MuiDialog-paper': {
					width: '420px',
					maxWidth: 'none',
				},
			}}>
			<div
				style={{
					position: 'relative',
					width: '420px',
					height: '160px',
					background: 'linear-gradient(90deg, #0B1FCB 0%, #9747FF 100%)',
					borderRadius: '18px 18px 0 0',
					overflow: 'hidden',
				}}>
				<img
					src={AIAccountantMan}
					alt='AIAccountant'
					style={{
						width: '124px',
						objectFit: 'contain',
						position: 'absolute',
						top: 'calc(50% + 15px)',
						left: '50%',
						transform: 'translate(-50%, -50%)',
					}}
				/>

				<IconButton
					aria-label='close'
					onClick={handleCloseSubFinalize}
					sx={{
						position: 'absolute',
						top: '8px',
						right: '8px',
						color: '#ffffff',
						padding: '8px',
						userSelect: 'none',
						backgroundColor: 'transparent',
						outline: 'none',
						'&:focus': { outline: 'none' },
						'&:active': { backgroundColor: 'transparent' },
					}}>
					<img
						src={AIHeaderClose}
						alt='AIHeaderClose'
						style={{
							width: '24px',
							height: '24px',
							objectFit: 'contain',
							pointerEvents: 'none',
						}}
					/>
				</IconButton>
			</div>

			<DialogContent
				sx={{
					padding: '18px',
					height: 'auto',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					overflowY: 'auto',
					scrollbarWidth: 'thin', // Firefox support
					scrollbarColor: '#8791b4 #f1f1f1', // Firefox support

					/* Scrollbar Webkit (Chrome, Safari, Edge) */
					'&::-webkit-scrollbar': {
						width: '10px',
						backgroundColor: '#f1f1f1',
					},
					'&::-webkit-scrollbar-track': {
						backgroundColor: '#e0e0ff',
						borderRadius: '10px',
					},
					'&::-webkit-scrollbar-thumb': {
						backgroundColor: '#8791b4',
						borderRadius: '10px',
						border: '2px solid #e0e0ff',
					},
					'&::-webkit-scrollbar-thumb:hover': {
						backgroundColor: '#6c7493',
					},
				}}>
				<div style={{ width: '100%' }}>
					<div
						style={{
							fontSize: '16px',
							fontWeight: '700',
							color: '#0b0f31',
							margin: '4px 0',
						}}>
						{i18n.t('provider.subfinalizetitle')}
					</div>
					<div
						style={{
							fontSize: '14px',
							fontWeight: '500',
							color: '#4b5080',
							margin: '4px 0',
						}}>
						{i18n.t('provider.subfinalizesubtitle')}
					</div>
					<div
						style={{
							fontSize: '12px',
							fontWeight: '500',
							color: '#4b5080',
							margin: '4px 0',
						}}>
						{i18n.t('provider.subfinalizesubnote')}
					</div>

					<div style={{ display: 'flex', margin: '18px 0' }}>
						<SelectorOption
							label={i18n.t('provider.subfintransfer')}
							// subLabel={i18n.t('provider.subfintransfersub')}
							icon={
								selectedOption === 'transfer' ? GeneralBlueTick : IconAIMedium
							}
							isSelected={selectedOption === 'transfer'}
							onClick={() => handleSelectOption('transfer')}
							borderRadius='8px 0 0 8px'
							borderSides={{ top: true, right: true, bottom: true, left: true }}
						/>
						<SelectorOption
							label={i18n.t('provider.subfincard')}
							// subLabel={i18n.t('provider.subfincardsub')}
							icon={selectedOption === 'card' ? GeneralBlueTick : IconAIHigh}
							isSelected={selectedOption === 'card'}
							// CURRENTLY ONLY TRANSFER AVAILABLE
							onClick={() => handleSelectOption('transfer')}
							borderRadius='0'
							borderSides={{
								top: true,
								right: true,
								bottom: true,
								left: false,
							}}
						/>
					</div>

					<div style={{ margin: '8px 0' }}>
						<CustomButton
							buttonName={
								providerSubscription.cardPayment === true
									? i18n.t('provider.subfinalizebuttonnext')
									: i18n.t('provider.subfinalizebuttonnext2')
							}
							buttonColor='#1c32f3'
							hoverColor='#0036cc'
							titleColor='#ffffff'
							titleHoverColor='#e0e0e0'
							width='100%'
							height='44px'
							padding='12px'
							onClick={async () => {
								try {
									saveRegDate();
									const data = {
										provider_subscription: providerSubscription,
										finishedRegistration: true,
										provider_package: providerPackage,
									};

									// MongoDB
									// const data = {'provider_subscription.companyname':''}

									await submitToDB(data);
									if (providerPackage.packageType === 'advanced') {
										sendEmailNotification('changePackageType', 'Advanced');
									} else if (providerPackage.packageType === 'premium') {
										sendEmailNotification('changePackageType', 'Premium');
									}
									setOpenSubFinalize(false);
									setOpenSubSuccess(true);
									console.log('DATA AFTER SUBMIT', data);
								} catch (error) {
									console.error('Error', error);
								}
							}}
						/>
					</div>
					<div style={{ margin: '8px 0' }}>
						<CustomButton
							buttonName={i18n.t('provider.subfinalizebuttoncancel')}
							onClick={handleCloseSubFinalize}
							buttonColor='#ffffff'
							hoverColor='#fafcfe'
							titleColor='#4b5080'
							titleHoverColor='#4b5080'
							width='100%'
							height='44px'
							padding='12px'
						/>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default SubscriptionFinalize;
